import styled, { device, themeGet } from "@theme/utils";

export const ContactUsPageArea = styled.div`
    padding-top: 70px;
    padding-bottom: 80px;
`;
